<template>
  <div class="bg-white rounded-lg shadow p-5 text-left">
    <div class="flex items-center mb-4">
      <span class="material-symbols-outlined text-blue-800 mr-2">{{ icon }}</span>
      <h2 class="text-lg font-semibold text-gray-800 text-left">{{ title }}</h2>
    </div>

    <div v-if="loading" class="flex flex-col items-center justify-center py-8">
      <div class="w-8 h-8 border-4 border-blue-200 border-t-blue-800 rounded-full animate-spin"></div>
    </div>

    <div v-else-if="!items.length" class="text-sm text-gray-500 text-left py-4">
      No data available yet.
    </div>

    <div v-else class="space-y-3">
      <div v-for="(item, index) in items" :key="item.label" class="text-left">
        <div class="flex items-center justify-between gap-2 mb-1">
          <span class="text-sm font-medium text-gray-700 text-left inline-flex items-center min-w-0">
            <span
              v-if="index === 0 && !item.isUnallocated"
              class="material-symbols-outlined text-sm text-yellow-600 mr-1 shrink-0"
              title="Leading"
            >
              workspace_premium
            </span>
            <span class="truncate">{{ item.label }}</span>
          </span>
          <span class="text-sm font-semibold text-gray-800 shrink-0">{{ item.count }}</span>
        </div>
        <div class="h-2 bg-gray-100 rounded-full overflow-hidden">
          <div
            class="h-full rounded-full"
            :class="item.isUnallocated ? 'bg-gray-300' : 'bg-gradient-to-r from-blue-800 to-blue-600'"
            :style="{ width: `${maxCount ? (item.count / maxCount) * 100 : 0}%` }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminBreakdownCard',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'bar_chart'
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    maxCount() {
      return this.items.reduce((max, item) => Math.max(max, item.count), 0);
    }
  }
};
</script>
